module.exports = __webpack_public_path__ + "img/lijiruzhu.54ca57d9.png";